import Vue from "vue";
import App from "./App.vue";

// Plugins
import tvaMq from "./plugins/tvaMq";
Vue.use(tvaMq, {
  mobile: 500,
  tablet: 1279,
  desktop: Infinity,
  large: Infinity,
});

import globalVariables from "./plugins/globalVariables";
Vue.use(globalVariables);

// Json viewer

Vue.config.productionTip = false;

// Svg icon
import VueSVGIcon from "vue-svgicon";
import "vue-svgicon/dist/polyfill";
import "@/compiled-icons";

// Vue3 touch events
import Vue2TouchEvents from "vue2-touch-events";
Vue.use(Vue2TouchEvents);

import router from "./utilities/router";
import store from "./utilities/store";
import i18n from "./utilities/language";
// Social sharing
import SocialSharing from "vue-social-sharing";
Vue.use(SocialSharing);

Vue.use(VueSVGIcon);
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
